import { Box, Flex } from "rebass";
import config from "../../utils/globalConfig";
import { getLocalizedString } from "../../utils";
import SwitchSwap from "../common/SwitchSwap";
import { useDispatch, useSelector } from "react-redux";
import { systemActions } from "../../logic/actions";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import useOrderType from "../../hooks/useOrderType";

const OrderTabs = ({
  catalogueTab,
  setCatalogueTab,
  expandable = false,
  expand = () => null,
  isExpanded = true,
  ...props
}) => {
  const dispatch = useDispatch();
  const { order } = useSelector((state) => state.yodaOrders);

  const isSwap = order?.orderTypeId === config.ORDER_TYPE_SWAP;

  const { isSwapEnabledForOrder } = useOrderType();

  return (
    <Flex
      width={1}
      maxWidth={config.VIEWPORT}
      backgroundColor={"white"}
      {...props}
    >
      <Flex
        width={1}
        height={45}
        justifyContent="space-between"
        alignItems="center"
        style={{ backgroundColor: "#a2a2a2" }}
      >
        <Flex>
          <Flex
            ml={3}
            p={0}
            bg={catalogueTab == 0 ? "white" : ""}
            color={catalogueTab == 0 ? "" : "white"}
            width={140}
            alignItems="center"
            justifyContent="center"
            height={40}
            style={{
              fontSize: "0.8em",
              top: "4px",
              position: "relative",
              cursor: catalogueTab == 0 ? "" : "pointer",
            }}
            onClick={() => {
              if (catalogueTab == 1) {
                setCatalogueTab(0);
                dispatch(systemActions.setTab(0));
              }
            }}
          >
            {getLocalizedString("REORDER")}
          </Flex>
          {isSwap && (
            <Flex
              p={0}
              width={140}
              bg={catalogueTab == 1 ? "white" : ""}
              color={catalogueTab == 1 ? "" : "white"}
              alignItems="center"
              justifyContent="center"
              height={40}
              style={{
                fontSize: "0.8em",
                top: "4px",
                position: "relative",
                cursor: catalogueTab == 1 ? "" : "pointer",
              }}
              onClick={() => {
                if (catalogueTab == 0) {
                  setCatalogueTab(1);
                  dispatch(systemActions.setTab(1));
                }
              }}
            >
              {getLocalizedString("SWAP")}
            </Flex>
          )}
        </Flex>
        <Flex alignItems={"center"} pr="10px">
          {isSwapEnabledForOrder() && (
            <>
              <Box
                fontSize="14px"
                color="white"
                sx={{ cursor: "pointer", mr: "4px" }}
                onClick={() => {
                  dispatchEvent(
                    new CustomEvent("switchOrderRequest", {
                      bubbles: true,
                    }),
                  );
                }}
              >
                {isSwap
                  ? getLocalizedString("SWITCH_SWAP_HIDE")
                  : getLocalizedString("SWITCH_SWAP")}
              </Box>
              <SwitchSwap />
            </>
          )}
          <Box
            onClick={expand}
            sx={{
              "& > svg > g > g > line": { stroke: "white" },
              cursor: expandable ? "pointer" : "default",
              visibility: expandable ? "visible" : "hidden",
              backgroundColor: "#fff",
              mx: "5px",
            }}
          >
            <Box bg="#a2a2a2">
              {isExpanded ? (
                <BsChevronUp size="24px" color="white" />
              ) : (
                <BsChevronDown size="24px" color="white" />
              )}
            </Box>
          </Box>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default OrderTabs;
